import React from 'react';


const LotteryInfo = ({num, lnum, prize, cnum, onclick, mtxt}) => {
  const handleClick = () => {
    onclick(num);
  }

  return (
    <div onClick={handleClick} className="flex w-4/5 h-12 cursor-pointer justify-between items-center bg-blue-50 text-[#0987F3] rounded-lg font-bold text-lg px-10 mobile:px-0 mobile:text-sm mobile:flex-col mobile:h-20 mobile:py-2">
        <p>{num} орон таарсан / {prize}₮</p>
        <p>{cnum} харилцагч</p>
        <p>{mtxt}{lnum}</p>
    </div>
  );
}

export default LotteryInfo;